import React, { useState } from "react";

import { detailsLayoutOptions, topicLayoutOptions } from '../../config/progression'

import { Topic } from '.'
import { PackageImport, Select, TitleInput } from '../EditorFormElements'
import { FormFieldWrapper, SortableList } from "../Global";
import { EditorTabs } from "../Interface";

export const ProgressionForm = ({given, ...props}) => {
  const [detailsLayout,setDetailsLayout] = useState('')
  const onDetailsLayoutChange = (name,value) => setDetailsLayout(value);

  const generalTab = (
    <>
      <PackageImport />

      <FormFieldWrapper>
        <TitleInput
          label="Item Title"
          defaultText="Enter item title"
          multiline={true}
          help='Provide a title to display in the background. Use the "Enter" key to control the line breaks.'
          given={given.title}
        /> 
      </FormFieldWrapper>

    </>
  )

  const stylesTab = (
    <FormFieldWrapper>  

      <Select 
        label="Topic Intro" 
        name='topicLayout' 
        options={topicLayoutOptions}
        given={given.topicLayout}
      /> 
      <Select 
        label="Topic Details" 
        name='detailsLayout' 
        options={detailsLayoutOptions}
        given={given.detailsLayout}
        callback={onDetailsLayoutChange}
      /> 

    </FormFieldWrapper>
  )
    
  const contentTab = (
    <SortableList
      label="Topic"
      name="topics"
      given={given.topics}
      min={2}
      max={7}
    >
      <Topic 
        detailsLayout={detailsLayout}
      />
    </SortableList>
  )

  return (
    <EditorTabs
      general={generalTab}
      styles={stylesTab}
      content={contentTab}
    />
  );

}